document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.benefits-carousel').forEach(section => {
    const carousel = section.querySelector('.carousel-container');
    const nextBtn = section.querySelector('.carousel-next');
    const prevBtn = section.querySelector('.carousel-prev');

    if (!carousel) return;

    nextBtn?.addEventListener('click', () => {
      const card = carousel.querySelector('.benefit-card');

      carousel.scrollBy({
        left: card.offsetWidth + 20,
        behavior: 'smooth'
      });
    });

    prevBtn?.addEventListener('click', () => {
      const card = carousel.querySelector('.benefit-card');

      carousel.scrollBy({
        left: -(card.offsetWidth + 20),
        behavior: 'smooth'
      });
    });
  });
});